import _ from "underscore";
import SimpleCheckboxNodeRenderer from "../tree/SimpleCheckboxNodeRenderer";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";

export default function ProjectNodeRenderer(tree, selectorFilter, selectionHelper)
{
    SimpleCheckboxNodeRenderer.call(this, tree, selectorFilter, selectionHelper);
}

ProjectNodeRenderer.prototype = _.create(SimpleCheckboxNodeRenderer.prototype);

ProjectNodeRenderer.prototype.getTitle = function(entity) {
    return entity.name;
};

ProjectNodeRenderer.prototype.isNeedToPushDisabledClass = function(treeNode)
{
    return treeNode.getValue().archived;
};

ProjectNodeRenderer.prototype.generateLabel = function ( treeNode, labelEl )
{
    HierarchySelectorUtil.renderSimpleEntityName(this, treeNode, labelEl);
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/customerProjectSelector/ProjectNodeRenderer.js